import React from 'react';
import clsx from 'clsx';

import candidateStyles from '../styles.module.scss';
import styles from './styles.module.scss';

const Skeleton: React.FunctionComponent = () => {
  const classNames = clsx(styles.skeleton, candidateStyles.candidateIds);
  return (
    <React.Fragment>
      <span data-nosnippet className="visuallyHidden">
        Loading your candidate Numbers
      </span>
      <div className={classNames} aria-hidden="true">
        <p></p>
        <ul>
          <li>
            <span></span>
          </li>
          <li>
            <span></span>
          </li>
          <li>
            <span></span>
          </li>
        </ul>
      </div>
    </React.Fragment>
  );
};

export default Skeleton;
